export default __webpack_public_path__ + "static/details2-f3e68c46e3f081c3f17bbb7c899e44bc.png";